import { render } from "./Control4doc.vue?vue&type=template&id=73f5010e&scoped=true"
import script from "./Control4doc.vue?vue&type=script&lang=js"
export * from "./Control4doc.vue?vue&type=script&lang=js"

import "./Control4doc.vue?vue&type=style&index=0&id=73f5010e&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f5010e"]])

export default __exports__